import { useTitle } from 'contexts/TitleContext'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

export default function DateRangeColumnFilter({ column }) {
  // Desestructuración de propiedades relevantes de 'column'
  const { filterValue, setFilter } = column

  // Obtiene el valor de filtro previo guardado en localStorage
  const previousFilter = localStorage.getItem(column.id)

  // Accede al contexto de título para posibles actualizaciones relacionadas
  const { title } = useTitle()

  // useEffect para guardar el valor actual del filtro en localStorage cuando este cambia
  useEffect(() => {
    localStorage.setItem(column.id, JSON.stringify(filterValue))
  }, [previousFilter, filterValue])

  // useEffect para cargar el filtro previo al montarse el componente o cuando el título cambia
  useEffect(() => {
    if (
      previousFilter !== 'undefined' &&
      previousFilter &&
      previousFilter.trim() !== ''
    ) {
      if (previousFilter.includes('[')) {
        setFilter(JSON.parse(previousFilter))
      } else {
        setFilter(
          previousFilter.split(',').filter((item) => {
            return item.trim() === '' ? ' ' : item
          })
        )
      }
    }
  }, [title])

  return (
    <div className="flex flex-col space-y-1 print:hidden">
      {/* Fecha inicio */}
      <input
        type="date"
        className={`w-full py-1 pr-1 border-2 border-gray-200 cursor-pointer focus:ring-opacity-40 focus:outline-none focus:ring focus:border-gray-400 focus:ring-gray-300 dark:focus:border-gray-300 hover:border-gray-300 font-noto font-normal rounded-sm px-1 text-gray-400 text-sm`}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setFilter((old = []) => [e.target.value, old[1]])}
        value={filterValue ? filterValue[0] : ''}
      />

      {/* Fecha fin */}
      <input
        type="date"
        className={`w-full py-1 pr-1 border-2 border-gray-200 cursor-pointer focus:ring-opacity-40 focus:outline-none focus:ring focus:border-gray-400 focus:ring-gray-300 dark:focus:border-gray-300 hover:border-gray-300 font-noto font-normal rounded-sm px-1 text-gray-400 text-sm`}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setFilter((old = []) => [old[0], e.target.value])}
        value={filterValue ? filterValue[1] : ''}
      />
    </div>
  )
}

DateRangeColumnFilter.propTypes = {
  column: PropTypes.object.isRequired
}
